import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/blogger-b': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M446.6 222.7C444.8 214.7 439.8 207.3 434.1 204.2 432.3 203.2 421.1 202 409.1 201.5 389 200.6 386.8 200.2 380.4 196.5 370.3 190.6 367.6 184.2 367.5 167 367.4 134 353.7 103.3 326.6 75.7 307.3 56 285.7 42.7 261.1 35.2 255.2 33.4 242 32.8 197.8 32.3 128.4 31.5 113 32.9 89.4 42.3 45.9 59.5 14.7 96.1 3.3 142.9 1.2 151.7 0.7 165.8 0.2 246.8-0.4 348.3 0.3 363.2 6.6 383.3 22.2 432.9 66.5 469.6 111 477.6 125.8 480.3 308.3 480.9 327 478.4 359.5 474 385 460.9 408.9 436.5 426.2 418.8 437 399.7 444.1 374.4 449 356.8 448.6 231.6 446.6 222.7zM124.5 159.1C132.3 151.2 134.5 150.9 183.3 150.9 227.2 150.9 228.7 151 235.1 154.3 244.4 159 248.5 165.6 248.5 176.2 248.5 185.7 244.7 192.4 236.2 197.8 231.6 200.7 228.9 200.9 185.9 201.1 159.4 201.3 138.2 200.7 135.1 199.9 118.5 195.2 112.3 171.4 124.5 159.1zM316.3 358.9L301.4 361.3 223.9 362.2C155.8 363 136.6 361.8 133 360.2 125.9 357.1 119.2 348.5 118.1 340.8 117 333.5 120.7 323.5 126.3 318.4 133.4 312 136.5 311.8 223.6 311.7 313.2 311.6 312.7 311.6 321.2 319.5 333.3 330.8 330.7 350.7 316.3 358.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/blogger-b.js
// module id = 6Ywo
// module chunks = 144